<script type="text/ecmascript-6">
    export default {
        methods: {
            format_price(price, currency){
                return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price);
            },
        }
    }
</script>